import React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { useQuery } from 'react-query';

import { defaultWalletCurrency, currencyFormat } from '@investown/fe/common-utils';
import { QueryKeys, refetchIntervals, getWallet } from '@investown/fe/api-sdk';

import SkeletonRow from 'components/SkeletonRow';

export const SimpleWalletBalance: React.FC = () => {
  const intl: IntlShape = useIntl();
  const wallet = useQuery(QueryKeys.Wallet, getWallet, {
    refetchInterval: refetchIntervals.fiveMinutes,
  });
  // TODO: get currency from backend when real wallet is implementeds

  return (
    <>
      {wallet.isLoading && <SkeletonRow width={70} />}

      {wallet.isSuccess && (
        <span>
          {currencyFormat({
            input: wallet.data.Wallet.availableBalance,
            currency: defaultWalletCurrency,
            locale: intl.locale,
          })}
        </span>
      )}
    </>
  );
};
